class Details extends DrupalBehavior {

  emailBtn(context) {
    if (context.querySelector('#emailWindowLocation')) {
      context.getElementById('emailWindowLocation').setAttribute('href', `mailto:?subject=Guthrie.org - ${window.document.title}&body=${window.location}`);
    }
  }



  // content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"

  onContent(context) {

    this.emailBtn(context);

    $('.provider-accordion h2.title', context).on('click', function() {
      $(this).toggleClass('active');
      $(this).siblings('.accordion-item').slideToggle('fast');
    });

    $('.patient-ratings .column-wrap .column .rating, .provider-rating .rating').each(function(){
      const firstRender = $(this).attr(`data-first-render`);
      if (firstRender && firstRender.toString().toLowerCase() !== `true`) return;
      if (firstRender && firstRender.toString().toLowerCase() === `true`) $(this).attr(`data-first-render`, `false`);
      let ratingNumber = $(this).attr('data-rating');
      let ratingWidth = $(this).width();
      let ratingPercentage = Math.floor((ratingNumber / 5) * 100);
      $(this).css('width', `${ratingWidth * (ratingPercentage * .01)}px`);
    });

    var iframe = $('.provider-wrap .provider-top .video-modal').find('iframe');
    var url = iframe.attr('src');
    if (url && url.includes("http://")) {
        iframe.attr('src', url.replace("http://", "https://"));
    }

    enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.md_min'].query, {
      match: () => {
        $('.provider-accordion.education h2.title, .provider-accordion.news-video h2.title, .provider-accordion.clinical-trials h2.title').addClass('active');
        $('.provider-accordion.education h2.title, .provider-accordion.news-video h2.title, .provider-accordion.clinical-trials h2.title').siblings('.accordion-item').slideDown('fast');
      },
    });
    enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.sm_max'].query, {
      match: () => {
        $('.provider-accordion.education h2.title, .provider-accordion.news-video h2.title, .provider-accordion.clinical-trials h2.title').removeClass('active');
        $('.provider-accordion.education h2.title, .provider-accordion.news-video h2.title, .provider-accordion.clinical-trials h2.title').siblings('.accordion-item').slideUp('fast');
      },
    });

    /**
     * Scheduling iFrame
     */

     const schedulingIframe = $(`#openSchedulingFrame`);

     if (schedulingIframe) {
       console.log($(schedulingIframe).contents().find(".slotdetailaction"));
       $(schedulingIframe).contents().find(".slotdetailaction").css("background-color", '#0072CE');
     }

  }

}

DrupalBehavior.register('guthrie_fap', 'details', Details);
